module.exports = {
  iconRefreshData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round' stroke='currentColor' stroke-width='2'%3e%3cpath d='M20.128 2l-.493 5.635L14 7.142M19.44 6.935a9 9 0 101.023 8.134'/%3e%3c/g%3e%3c/svg%3e",
  iconRefreshWidth: 24,
  iconRefreshHeight: 24
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/tokens/base/icon/refresh.js
// module id = 395
// module chunks = 7